import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { ChefHat } from 'lucide-react';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="container">
                <div className="footer-inner">
                    {/* Brand Section */}
                    <div className="footer-col footer-brand-col">
                        <div className="footer-brand">NutriLens</div>
                        <p>Bringing your nutrition into focus with delicious, healthy recipes and a vibrant community of food lovers.</p>
                        <div className="socials">
                            <motion.a href="#" whileHover={{ scale: 1.08 }} className="social-link" aria-label="Instagram"><FaInstagram /></motion.a>
                            <motion.a href="#" whileHover={{ scale: 1.08 }} className="social-link" aria-label="Twitter"><FaTwitter /></motion.a>
                            <motion.a href="#" whileHover={{ scale: 1.08 }} className="social-link" aria-label="Facebook"><FaFacebook /></motion.a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-col">
                        <h3>Quick Links</h3>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/feed">Recipe Feed</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                        </ul>
                    </div>

                    {/* Features */}
                    <div className="footer-col">
                        <h3>Features</h3>
                        <ul>
                            <li>Smart Recipe Search</li>
                            <li>Personalized Feed</li>
                            <li>Community Driven</li>
                            <li>Nutritional Insights</li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-col">
                        <h3>Get in Touch</h3>
                        <div className="info-list">
                            <div className="info-item">
                                <FaEnvelope />
                                <span>heygouri79@gmail.com</span>
                            </div>
                            <div className="info-item">
                                <FaPhone />
                                <span>+91 7887483031</span>
                            </div>
                            <div className="info-item">
                                <FaMapMarkerAlt />
                                <span>Bangalore, Karnataka, India</span>
                            </div>
                        </div>
                        <div className="mt-16">
                            <h4>Stay Updated</h4>
                            <div style={{ display: 'flex' }}>
                                <input type="email" placeholder="Your email" style={{ flex: 1, padding: '10px 12px', background: '#0b1220', border: '1px solid #1f2937', color: '#fff', borderRadius: '6px 0 0 6px' }} />
                                <button className="btn btn-primary" style={{ borderRadius: '0 6px 6px 0' }}>Subscribe</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} NutriLens. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;